var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.salesApplicationExists)?_c('DataTableV2PaginatedMobile',{attrs:{"api":_vm.api,"propTitle":_vm.propTitle,"description":_vm.computedDescription,"configuration":_vm.configuration}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }